let handle = {
    //读取
    get: function(b) {
        var c = new RegExp("(^|;|\\s+)" + b + "=([^;]*)(;|$)"),
            a = document.cookie.match(c);

        return (!a ? '' : unescape(a[2]));
    }
}

export default handle;
